module.exports = __webpack_public_path__ + "static/media/Desenvolvedor Frontend - thiago ramos.e7af5d37.pdf";